// Utility functions for mobile features

// Click to call
export const callPhone = (phoneNumber) => {
  if (!phoneNumber) return;
  
  // Clean phone number
  const cleanNumber = phoneNumber.replace(/[^0-9+]/g, '');
  
  // Open phone dialer
  window.location.href = `tel:${cleanNumber}`;
};

// Click to email
export const sendEmail = (email, subject = '', body = '') => {
  if (!email) return;
  
  const mailtoLink = `mailto:${email}${subject ? `?subject=${encodeURIComponent(subject)}` : ''}${body ? `&body=${encodeURIComponent(body)}` : ''}`;
  
  window.location.href = mailtoLink;
};

// Open camera for photo capture
export const openCamera = (onCapture) => {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = 'image/*';
  input.capture = 'environment'; // Use back camera
  
  input.onchange = (e) => {
    const file = e.target.files[0];
    if (file && onCapture) {
      onCapture(file);
    }
  };
  
  input.click();
};

// Check if running as PWA
export const isPWA = () => {
  return window.matchMedia('(display-mode: standalone)').matches ||
         window.navigator.standalone ||
         document.referrer.includes('android-app://');
};

// Request notification permission
export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    console.log('This browser does not support notifications');
    return false;
  }
  
  if (Notification.permission === 'granted') {
    return true;
  }
  
  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }
  
  return false;
};

// Show local notification
export const showNotification = (title, options = {}) => {
  if (Notification.permission === 'granted') {
    new Notification(title, {
      icon: '/revo-app-logo.png',
      badge: '/revo-app-logo.png',
      ...options
    });
  }
};

// Vibrate device
export const vibrate = (pattern = [200, 100, 200]) => {
  if ('vibrate' in navigator) {
    navigator.vibrate(pattern);
  }
};

// Share content (Web Share API)
export const shareContent = async (data) => {
  if (navigator.share) {
    try {
      await navigator.share(data);
      return true;
    } catch (err) {
      console.log('Error sharing:', err);
      return false;
    }
  }
  return false;
};

// Check if device is mobile
export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

// Get device type
export const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'tablet';
  }
  if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    return 'mobile';
  }
  return 'desktop';
};

// Install PWA prompt
export const installPWA = (deferredPrompt) => {
  if (deferredPrompt) {
    deferredPrompt.prompt();
    deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the install prompt');
      }
      return null;
    });
  }
};

// Register service worker with force update
export const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      // Force update check
      const registration = await navigator.serviceWorker.register('/service-worker.js', { updateViaCache: 'none' });
      // Check for updates immediately
      registration.update();
      console.log('Service Worker registered:', registration);
      return registration;
    } catch (error) {
      console.log('Service Worker registration failed:', error);
      return null;
    }
  }
  return null;
};